<template>
    <div id="logUser">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item>日志查看</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="text-align:left; height:56px; color:#666">
            <span style="margin-left:30px;line-height:40px;">操作人：</span>
            <el-input v-model="search.operator" placeholder="请输入内容" style="width:200px;"></el-input>
            <span style="margin-left:30px;line-height:40px;">操作名：</span>
            <el-input v-model="search.operation" placeholder="请输入内容" style="width:200px;"></el-input>
            <span style="margin-left:30px">操作时间：</span>
            <el-date-picker v-model="scanTime" style="width:400px" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="scanTimeChange">
            </el-date-picker>
            <span style="margin-left:30px"></span>
            <el-button icon="el-icon-search" type="success" @click="getLogList" circle ></el-button>
            <el-button icon="el-icon-delete" type="danger" @click="clear" circle></el-button>
        </div>
        <template class="table">
            <el-table :data="logList" ref="logList"  style="width: 100%">
                <el-table-column prop="operationTime" align="center" label="操作时间"> </el-table-column>
                <el-table-column prop="operator" align="center" label="操作者"></el-table-column>
                <el-table-column prop="operation" align="center" label="操作名"></el-table-column>
                <el-table-column prop="operationMethod" align="center" label="操作方法"></el-table-column>
                <el-table-column prop="parames" align="center" label="入参" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="result" align="center" label="返参" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="resultState" align="center" label="返回状态"></el-table-column>
                <el-table-column prop="ipadderss" align="center" label="IP地址"></el-table-column>
                <el-table-column prop="remarks" align="center" label="备注" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </template>
        <div class="page">
            <el-pagination  :page-size="rows" :page-count="page" :page-sizes="[10,20,50, 100]" layout="total, prev, pager, next,sizes" :total="tablePage" @current-change='changePage' @size-change="changeSize" style="text-align:right"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name:'logUser',
    data(){
        return{
            logList:[],
            tablePage:0,
            page:1,
            rows:10,
            search:{
                page:1,
                rows:10,
                operator:'',
                operation:'',
                startTime:'',
                endTime:''
            },
            scanTime:[]
        }
    },
    mounted(){
        this.getLogList();
    },
    methods:{
        getLogList(){
            this.search.page=this.page
            this.search.rows=this.rows
            this.$ajax.post(this.$domain.listLogUser,this.search)
            .then(ret=>{
                console.log(ret.data)
                var res=ret.data;
                if(res.code=="200"){
                    this.logList=res.data.list;
                    this.tablePage=res.data.count;
                }
                else if(res.code=='201'){
                    this.logList=[];
                    this.tablePage=0;
                }
                else if(res.code=='502'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
            })
        },
        // 分页(OK)
        changePage(val){
            this.page=val
            this.getLogList()
        },
        changeSize(val){
            this.rows=val
            this.getLogList()
        },
        scanTimeChange(val){
            if(val==null){
                this.search.startTime='';
                this.search.endTime='';
            }
            else{
                this.search.startTime=this.$common.format(val[0],'yyyy-MM-dd hh:mm:ss');
                this.search.endTime=this.$common.format(val[1],'yyyy-MM-dd hh:mm:ss');
            }
        },
        clear(){
            this.scanTime=[]
            this.search={
                page:1,
                rows:this.rows,
                operator:'',
                operation:'',
                startTime:'',
                endTime:''
            }
            this.getLogList()
        }
    }
}
</script>

<style>
#logUser{
        width:100%;
        min-width: 1200px;
        padding:0 10%;
        box-sizing: border-box;
    }
    #logUser .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    .el-table{
        cursor: pointer;
    }
    .el-table .selected-row{
        background:#cee3e9;
    }
</style>


// WEBPACK FOOTER //
// src/page/logUser.vue